// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZXNG","question":"styles_question__yd_zg","inputVisibleButton":"styles_inputVisibleButton__1C643","note":"styles_note__1vxBZ"};